var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "label": _vm.label
    },
    model: {
      value: _vm.email1,
      callback: function callback($$v) {
        _vm.email1 = $$v;
      },
      expression: "email1"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1), _vm._v(" @ "), _c('v-col', [_c('v-text-field', _vm._b({
    model: {
      value: _vm.email2,
      callback: function callback($$v) {
        _vm.email2 = $$v;
      },
      expression: "email2"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }